<script setup>
import { ref } from 'vue';
import DealerCard from '@/components/cards/DealerCard.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Grid, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import '@/assets/styles/swiper-custom.scss';
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
const breakpoints = {
  320: {
    slidesPerView: 2.005,
    slidesPerGroup: 2,
    spaceBetween: 8,
    grid: { rows: 4, fill: 'row' },
  },
  768: {
    slidesPerView: 4.005,
    slidesPerGroup: 4,
    spaceBetween: 8,
    grid: { rows: 3, fill: 'row' },
  },
  1270: {
    slidesPerView: 6,
    slidesPerGroup: 6,
    spaceBetween: 8,
    grid: { rows: 2, fill: 'row' },
  },
};

const hoveredCard = ref(null);
const setHoveredCard = (cardId) => {
  hoveredCard.value = cardId;
};

const clearHoveredCard = () => {
  hoveredCard.value = null;
};
</script>
<template>
  <div
    :class="['brands__slider', hoveredCard !== null ? 'has-hovered-card' : '']"
  >
    <Swiper
      :slides-per-view="'auto'"
      :space-between="16"
      :modules="[Grid, Navigation, Pagination]"
      :grid="{ rows: 2, fill: 'row' }"
      :breakpoints="breakpoints"
      :navigation="{
        prevEl: '.brands__slider-navigation-prev',
        nextEl: '.brands__slider-navigation-next',
      }"
      :pagination="{
        el: '.brands__slider-pagination',
      }"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
      @swiper="onSwiper"
      @lock="onLockToggle"
      @unlock="onLockToggle"
    >
      <SwiperSlide v-for="(item, itemIndex) in items" :key="itemIndex">
        <DealerCard
          :view="'brand'"
          :is-first="itemIndex === 0"
          :title="item?.title"
          :logo="item?.logo"
          :url="item?.url"
          :background-color="backgroundColor"
          :class="{
            'is-blurred': hoveredCard !== null && hoveredCard !== itemIndex,
            'is-hovered': hoveredCard === itemIndex,
          }"
          @mouseenter="setHoveredCard(itemIndex)"
          @mouseleave="clearHoveredCard"
        />
      </SwiperSlide>
    </Swiper>
    <div
      v-show="!isLocked"
      class="swiper-pagination swiper-pagination--onblack brands__slider-pagination"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
    ></div>
    <div
      v-show="!isLocked"
      class="swiper-navigation brands__slider-navigation"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
    >
      <Button
        type="button"
        rounded
        variant="outlined"
        class="brands__slider-navigation-prev button-prev js-button-brands-prev"
      >
        <CIcon
          class="button-prev__icon"
          :name="
            backgroundColor === 'black' ? 'direction-white' : 'direction-black'
          "
          width="16"
          height="16"
        />
      </Button>
      <Button
        type="button"
        rounded
        variant="outlined"
        class="brands__slider-navigation-next button-next js-button-brands-next"
      >
        <CIcon
          class="button-next__icon"
          :name="
            backgroundColor === 'black' ? 'direction-white' : 'direction-black'
          "
          width="16"
          height="16"
        />
      </Button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'sass:math';
.brands {
  &__slider {
    .swiper {
      height: 100%;
      overflow: visible;
      width: 100%;
    }
    &.has-hovered-card {
      @include media-breakpoint-up(md) {
        :deep(.dealer) {
          transition: all 0.3s ease;
          &.is-blurred {
            opacity: 0.5;
          }
          &.is-hovered {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
